export const firebaseConfig = {
  apiKey: 'AIzaSyAwb9MoOeAPJHi1Rs-G3JKsAJgXh80gEiQ',
  authDomain: 'signi-translations-management.firebaseapp.com',
  databaseURL: 'https://signi-translations-management-default-rtdb.europe-west1.firebasedatabase.app',
  projectId: 'signi-translations-management',
  storageBucket: 'signi-translations-management.appspot.com',
  messagingSenderId: '294803497607',
  appId: '1:294803497607:web:8732e6f7a55ee29fafce22',
};
